export enum SessionKeys {
  HaveTriedToReload = 'have-tried-to-reload',
}
